/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import type { ButtonAsType, ButtonProps } from '@THC/components/Button';

import ROUTES from 'Utilities/routes';

import { MOTORWAY_MOVE_UNAUTHORISED_PARAM } from '../DiscoverMWMove.consts';

type DWMPHeroButtonProps<E extends ButtonAsType> = Omit<ButtonProps<E>, 'label'>;

export const getDiscoverMotorwayMoveRedirectLink = (hash: string) => {
	return `${ROUTES.SIGN_IN.href}?redirect=${encodeURIComponent(
		`${ROUTES.MOTORWAY_MOVE.href}#${hash}`,
	)}&unauthorised=${MOTORWAY_MOVE_UNAUTHORISED_PARAM}`;
};

export const getDiscoverMotorwayMoveButtonParams = ({
	hash,
	isLoggedOut,
	onClick,
}: {
	hash: string;
	isLoggedOut?: boolean;
	onClick?: () => void;
}) =>
	isLoggedOut
		? ({
				as: 'a',
				href: getDiscoverMotorwayMoveRedirectLink(hash),
				onClick,
		  } as DWMPHeroButtonProps<'a'>)
		: ({
				onClick,
		  } as DWMPHeroButtonProps<'button'>);
